import { getMimeType } from './helpers'

/**
 * Resize image to specific dimentsions
 *
 * @param {string} base64image
 * @param {number} width
 * @param {number} height
 * @returns {Promise<string>}   - return base64 of resized image
 */
export default (base64image, width = 2500, height = 2500) => {
    let imageElement = new Image()
    imageElement.src = base64image

    return new Promise(resolve => {
        imageElement.onload = () => {
            // Check if the image require resize at all
            if (imageElement.height <= height && imageElement.width <= width) {
                return resolve(base64image)
            }

            // Make sure the width and height preserve the original aspect ratio and adjust if needed
            if (imageElement.height > imageElement.width) {
                width = Math.floor(height * (imageElement.width / imageElement.height))
            } else {
                height = Math.floor(width * (imageElement.height / imageElement.width))
            }

            let resizingCanvas = document.createElement('canvas')
            let resizingCanvasContext = resizingCanvas.getContext('2d')

            // Start with original image size
            resizingCanvas.width = imageElement.width
            resizingCanvas.height = imageElement.height


            // Draw the original image on the (temp) resizing canvas
            resizingCanvasContext.drawImage(imageElement, 0, 0, resizingCanvas.width, resizingCanvas.height)

            let curImageDimensions = {
                width: Math.floor(imageElement.width),
                height: Math.floor(imageElement.height)
            }

            let halfImageDimensions = {
                width: null,
                height: null
            }

            // Quickly reduce the size by 50% each time in few iterations until the size is less then
            // 2x time the target size - the motivation for it, is to reduce the aliasing that would have been
            // created with direct reduction of very big image to small image
            while (curImageDimensions.width * 0.5 > width) {
                // Reduce the resizing canvas by half and refresh the image
                halfImageDimensions.width = Math.floor(curImageDimensions.width * 0.5)
                halfImageDimensions.height = Math.floor(curImageDimensions.height * 0.5)

                resizingCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                    0, 0, halfImageDimensions.width, halfImageDimensions.height)

                curImageDimensions.width = halfImageDimensions.width
                curImageDimensions.height = halfImageDimensions.height
            }

            // Now do final resize for the resizingCanvas to meet the dimension requirements
            // directly to the output canvas, that will output the final image
            let outputCanvas = document.createElement('canvas')
            let outputCanvasContext = outputCanvas.getContext('2d')

            outputCanvas.width = width
            outputCanvas.height = height

            outputCanvasContext.drawImage(
                resizingCanvas,
                0,
                0,
                curImageDimensions.width,
                curImageDimensions.height,
                0,
                0,
                width,
                height
            )

            // output the canvas pixels as an image. params: format, quality
            return resolve(outputCanvas.toDataURL(getMimeType(imageElement)))
        }
    })
}
